import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionPlanEnum } from '@therapist/shared/models/subscription/subscription-plan.enum';

@Pipe({ name: 'subscriptionPlanTranslations' })
export class SubscriptionPlanTranslationsPipe implements PipeTransform {

  transform(value: SubscriptionPlanEnum | undefined): string {
    switch (value) {
      case SubscriptionPlanEnum.SinglePracticeMonthly:
        return 'Einzelpraxis monatlich';

      case SubscriptionPlanEnum.SinglePracticeYearly:
        return 'Einzelpraxis jährlich';

      case SubscriptionPlanEnum.GroupPractice:
        return 'Gruppenpraxis';

      // Abo mit unbekannter Preis-ID (Plan fehlt im JSON)
      default:
        return 'Abo';
    }
  }
}
